import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const buttonsContainer = style([
  {
    display: 'flex',
    gap: space.s16,
    justifyContent: 'end',
    marginTop: space.s32,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    tablet: {
      flexDirection: 'row',
    },
  }),
]);

export const subTitle = style([
  { fontWeight: fontWeight.bold, marginBottom: space.s16 },
]);

export const inviteUserTabItem = style({
  flexGrow: 1,
  flexBasis: '50%',
  justifyContent: 'center',

  selectors: {
    '&:is(&)': {
      paddingBottom: space.s16,
    },
  },
});
